import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import Link from "components/link";
import Fab from "@material-ui/core/Fab";
import DisabledTooltip from "components/tooltip";
import styles from "./styles/dashboard-action-menu-icon.css.js";

const DashboardActionMenuIcon = ({
  className,
  classes,
  children,
  url,
  onClick,
  disabled = false,
  disabledTooltipText,
}) => {
  return url ? (
    <Link className={className} disabled={disabled} href={url} onClick={onClick}>
      <DisabledTooltip disabled={disabled} text={disabledTooltipText}>
        <div className={classes.dashboardactionmenu__icon}>
          <Fab disabled={disabled} color="secondary">
            {children}
          </Fab>
        </div>
      </DisabledTooltip>
    </Link>
  ) : (
    <DisabledTooltip disabled={disabled} text={disabledTooltipText}>
      <div className={classes.dashboardactionmenu__icon} onClick={onClick}>
        <Fab disabled={disabled} color="secondary">
          {children}
        </Fab>
      </div>
    </DisabledTooltip>
  );
};

DashboardActionMenuIcon.propTypes = {
  /**
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /*
   * Función que se llama al hacer click
   */
  onClick: PropTypes.func,
  /**
   * Url del icono
   */
  url: PropTypes.string,
  /**
   * Indica si el botón está deshabilitado
   **/
  disabled: PropTypes.bool,
  /**
   * Texto para mostrar en un tooltip en caso de que el botón esté deshabilitado.
   * En caso de no haber texto, no se muestra el tooltip
   **/
  disabledTooltipText: PropTypes.string,
};

export default withStyles(styles)(DashboardActionMenuIcon);
